import styled from 'styled-components';

export const NewsDetailsContainer = styled.div`
    display: flex;
    flex-direction: row;
    width: 100%;
    height: 100%;
    flex-wrap: wrap;
`;

export const NewsLoadingContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    height: 50vh;
`;

export const NewsTextContainer = styled.div`
    flex: 1;
    margin: 0;
    width: 100%;
`;

export const NewsGalleryContainer = styled.div`
    flex: 1;
    z-index: 1;
`;
